module.exports = __webpack_public_path__ + "img/app-qrcode.836aec32.png";